import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import COLORS, { GRAYS } from 'components/common/colors';
import ProfileCard from './profile_card';

export const StyledCardExpander = styled.div`
  border-bottom-left-radius: ${p => p.theme.borderRadius.default};
  border-bottom-right-radius: ${p => p.theme.borderRadius.default};
  border-top: 1px solid ${GRAYS.xxxlight};
  color: ${GRAYS.light};
  cursor: pointer;
  display: flex;
  justify-content: center;
  &:hover {
    background: ${GRAYS.xxxxlight};
    color: ${COLORS.green};
  }
`;

export const StyledChevron = styled.div`
  cursor: pointer;
  display: inline-block;
  transition: transform 0.15s ease;
  ${p =>
    p.isDownwards &&
    `
      transform: rotate(180deg);
      `};
`;

export default class ExpandableProfileCard extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { isExpanded: false };
    this.onClickExpander = this.onClickExpander.bind(this);
  }

  render() {
    let { limit, children, header, ...rest } = this.props;

    return (
      <ProfileCard {...rest} footer={this.renderExpander({ children, limit })}>
        {header}
        {this.renderChildren({ children, limit })}
      </ProfileCard>
    );
  }

  renderChildren({ children, limit }) {
    const fewerThanLimit = children.length <= limit;
    const renderedChildren = children.length ? (
      <React.Fragment>{fewerThanLimit || this.state.isExpanded ? children : children.slice(0, limit)}</React.Fragment>
    ) : null;
    return renderedChildren;
  }

  renderExpander({ children, limit }) {
    const fewerThanLimit = children.length <= limit;

    const expander = fewerThanLimit ? null : (
      <CardExpander isExpanded={this.state.isExpanded} onClick={this.onClickExpander} />
    );
    return expander;
  }

  onClickExpander() {
    this.setState(({ isExpanded }) => {
      return { isExpanded: !isExpanded };
    });
  }
}

export function CardExpander({ isExpanded, onClick }) {
  return (
    <StyledCardExpander onClick={onClick}>
      <StyledChevron className="ion-chevron-up" isDownwards={!isExpanded} onMouseDown={onMouseDown} />
    </StyledCardExpander>
  );
}

function onMouseDown(e) {
  e.preventDefault(); // Prevents selecting text if you click too much
}

CardExpander.propTypes = {
  isExpanded: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

ExpandableProfileCard.propTypes = {
  ...ProfileCard.propTypes,
  children: PropTypes.arrayOf(PropTypes.node),
  header: PropTypes.node,
  limit: PropTypes.number,
};

ExpandableProfileCard.defaultProps = {
  children: [],
  limit: 3,
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/profile/expandable_profile_card.jsx